import { UserDirectoryScreenContent } from "../../features/userDirectory";

function UserListScreen() {
  return (
    <section className="clients-page" id="Csection" tabIndex="-1">
      <div className="container">
        <UserDirectoryScreenContent />
      </div>
    </section>
  );
}

export default UserListScreen;
